import type { SubscriptionEventType } from '../constants';

export type SubscriptionEventTone = 'success' | 'warning' | 'danger' | 'info' | 'muted';

const EVENT_TONE_MAP: Record<SubscriptionEventType, SubscriptionEventTone> = {
  trial_started: 'info',
  trial_expired: 'muted',
  subscription_created: 'info',
  subscription_activated: 'success',
  subscription_renewed: 'success',
  subscription_expired: 'warning',
  subscription_cancelled: 'danger',
  payment_pending: 'warning',
  payment_paid: 'success',
  payment_failed: 'danger',
  payment_rejected: 'danger',
  entitlement_granted: 'success',
  entitlement_revoked: 'danger',
};

export function subscriptionEventTypeLabelKey(eventType: string): string {
  return `subscriptionEvents.eventTypes.${eventType}`;
}

export function subscriptionEventSourceLabelKey(eventSource: string): string {
  return `subscriptionEvents.eventSources.${eventSource}`;
}

export function resolveSubscriptionEventTone(eventType: string): SubscriptionEventTone {
  return EVENT_TONE_MAP[eventType as SubscriptionEventType] ?? 'muted';
}

export const SUBSCRIPTION_EVENT_TONE_STYLES: Record<SubscriptionEventTone, string> = {
  success: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
  danger: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  info: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
  muted: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
};
